import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Button from 'components/atoms/Button'
import { Container, SVGIcon } from 'components/qstrap'
import { branch } from 'baobab-react/higher-order'
import Typography from 'components/atoms/Typography'
import intl from 'react-intl-universal'

const LikeListNavbar = ({
  activeKind,
  schoolsCount,
  studyFieldsCount,
  professionsCount,
  scholarshipsCount,
}) => {
  const variant = kind => ((activeKind === kind) ? 'default' : 'secondary')

  return (
    <Container className="LikeListNavbar p-y-lg">
      <Typography component="h1" variant="title" className="title">
        <SVGIcon
          name="campus-love"
          size="md"
          className="m-r-sm"
          style={
            {
              position: 'relative',
              top: '7px',
            }
          }
        />
        {intl.get('molecules.LikeListNavbar.title')}
      </Typography>
      <div className="button-row m-t-sm">
        <Button className="action-link" component={Link} variant={variant('schools')} to="schools">
          {intl.get('molecules.LikeListNavbar.campuses')}
          <span className="m-l-md">{schoolsCount}</span>
        </Button>
        <Button className="action-link" component={Link} variant={variant('studyFields')} to="study_fields">
          {intl.get('molecules.LikeListNavbar.majors')}
          <span className="m-l-md">{studyFieldsCount}</span>
        </Button>
        <Button className="action-link" component={Link} variant={variant('professions')} to="professions">
          {intl.get('molecules.LikeListNavbar.careers')}
          <span className="m-l-md">{professionsCount}</span>
        </Button>
        <Button className="action-link" component={Link} variant={variant('scholarships')} to="scholarships">
          {intl.get('molecules.LikeListNavbar.scholarships')}
          <span className="m-l-md">{scholarshipsCount}</span>
        </Button>
      </div>
    </Container>
  )
}

LikeListNavbar.propTypes = {
  activeKind: PropTypes.string,
  schoolsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  studyFieldsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  professionsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scholarshipsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

LikeListNavbar.defaultProps = {
  activeKind: 'schools',
  schoolsCount: '-',
  studyFieldsCount: '-',
  professionsCount: '-',
  scholarshipsCount: '-',
}

export { LikeListNavbar }
export default branch({
  activeKind: ['serverProps', 'kind'],
  schoolsCount: ['serverProps', 'schoolsCount'],
  studyFieldsCount: ['serverProps', 'studyFieldsCount'],
  professionsCount: ['serverProps', 'professionsCount'],
  scholarshipsCount: ['serverProps', 'scholarshipsCount'],
}, LikeListNavbar)
